module.exports = __webpack_public_path__ + "static/media/webservice.a235f1b0.svg";